import { render } from "./SuccessStories.vue?vue&type=template&id=6714cdf2&scoped=true"
import script from "./SuccessStories.vue?vue&type=script&lang=js"
export * from "./SuccessStories.vue?vue&type=script&lang=js"

import "./SuccessStories.vue?vue&type=style&index=0&id=6714cdf2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6714cdf2"]])

export default __exports__